import { render, staticRenderFns } from "./QuestionMedication.vue?vue&type=template&id=04163200&scoped=true"
import script from "./QuestionMedication.vue?vue&type=script&lang=js"
export * from "./QuestionMedication.vue?vue&type=script&lang=js"
import style0 from "./QuestionMedication.vue?vue&type=style&index=0&id=04163200&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04163200",
  null
  
)

export default component.exports